import { getApiConfig } from './../../../../utilities';
import * as actions from './../../../../actions'
import * as PJActions from './../../../ProjectScope/ProjectScopeActions';
import customEvent from "../../../../utilities/customEvent";
const {get, post} = getApiConfig('Dashboard_Installation');

export const NewInstallationGroupItemActionTypes = {
  SHOW_OVERLAY: 'new-installation-group-item/show_overlay'
};

export function showNewInstallationGroupItemOverlay(group, show = true, data = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: NewInstallationGroupItemActionTypes.SHOW_OVERLAY,
      payload: { group, show, data }
    });
  }
}

export function saveNewInstallationGroupItem(data) {
  return (dispatch) => {
    return dispatch(actions.loadingDialog_show(true, 'Saving Installation...', 'Saving Installation Data...'))
      .then(() => post(data, 'SaveInstallation'))
      .then(() => document.dispatchEvent(customEvent('save-installation-validating')))
      .then(() => dispatch(PJActions.fetchData('Installation', 'Validating Saved Data')))
      .then(() => document.dispatchEvent(customEvent('save-installation-complete')))
  }
}
